// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typePickemMissingPicksListBody = {
  poolId: string;
  roundId: string;
  cursor?: string | null;
  limit?: number | null;
};

export type typePickemMissingPicksListOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    roundStatus: "scheduled" | "open" | "locked" | "graded";
    items: {
      userId: string;
      displayName: string;
      photoUrl?: string | null;
      picksMade: number;
      picksRequired: number;
      isNudged: boolean;
      nextLockAt?: string | null;
      entryId: string | null;
    }[];
    nextCursor: string | null;
  };
};

export type typePickemMissingPicksListOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePickemMissingPicksListOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePickemMissingPicksListOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaPickemMissingPicksListBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    roundId: { type: "string", maxLength: 3000, minLength: 1 },
    cursor: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    limit: { oneOf: [{ type: "integer" }, { enum: [null] }] },
  },
  required: ["poolId", "roundId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createPickemMissingPicksList(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaPickemMissingPicksListBody);
  }

  return async function postPickemMissingPicksList(
    payload: typePickemMissingPicksListBody,
  ): Promise<
    typePickemMissingPicksListOutput200 | typePickemMissingPicksListOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postPickemMissingPicksList" failed before calling the network. #c93f2bfac781`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#c93f2bfac781" },
        },
        data: null,
      } as typePickemMissingPicksListOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/pickem/missing-picks-list`,
      httpMethod: "POST",
      options,
    })) as
      typePickemMissingPicksListOutput200 | typePickemMissingPicksListOutput400;
  };
}
